  <iframe #equationEditor
          id="iframeEquationEditor"
          height="250"
          frameBorder="0"
          (load)="onEquationEditorLoaded()"
          [src]="equationEditorUrl"></iframe>
